import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useLoggedInUser from "../hooks/useLoggedInUser.js";
import { showLoginPopup } from "../../redux/actions/login.js";

export default function LoginWarning({}) {
	const user = useLoggedInUser();
	const dispatch = useDispatch();

	const clicked = () => {
		dispatch(showLoginPopup());
	};

	if(!!user.email) {
		return null;
	}
	return (
		<div
			onClick={clicked}
			className='full_page_width_header login_clicker'>
			You are not logged in!
		</div>
	);
}